import * as classNames from "classnames";
import {
    IHighStateCount,
    ILifeChangingEvent,
} from "motw_core/Entity/ILifeChangingEvent";
import * as React from "react";
import { LifeChangingEventAge } from "source/app/presentation/MainPanel/LifeChangingEvents/Age/LifeChangingEventAge";
import { DisplayLCEDirection } from "source/app/presentation/MainPanel/LifeChangingEvents/Direction/LCEDirection";
import { GetLifeChangingEventFloorColor } from "source/app/presentation/MainPanel/LifeChangingEvents/Helpers/LifeChangingEventFloor";
import { LCEPerspective } from "source/app/presentation/MainPanel/LifeChangingEvents/Perspective/LCEPerspective";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { GetColorString } from "../../DevTools/Texturizer/ColorPicker/ColorPicker";
import { ShowHighStateCount } from "./ShowHighStateCount";
import { ShowRating } from "./ShowRating";

export function LifeChangingEventsRow({
    row,
    highStateCounts,
}: {
    row: ILifeChangingEvent;
    highStateCounts: IHighStateCount[];
}) {
    const backgroundColorHSLA = GetLifeChangingEventFloorColor(row.perspective);
    const backgroundColor = GetColorString(backgroundColorHSLA);

    const containerClass = StyleClass(
        `lifeChangingEventRow_${backgroundColor}`,
        {
            width: "100%",
            backgroundColor,
            padding: "5px",
            display: "grid",
            gridTemplateColumns: "40px 40px 30px auto 20px 30px 30px 40px 40px",
            alignItems: `center`,
            justifyItems: `center`,
        }
    );

    const hscRecordsForYear = highStateCounts.filter(
        (hsc) => hsc.result_year === row.year
    );

    const numIForYear = hscRecordsForYear.reduce(
        (sum, hsc) => sum + hsc.result_num_i,
        0
    );

    const numPForYear = hscRecordsForYear.reduce(
        (sum, hsc) => sum + hsc.result_num_p,
        0
    );

    const compositeScore = Math.floor(row.perspective * (row.rating ?? 0));

    return (
        <div className={classNames([containerClass])}>
            <LifeChangingEventAge year={row.year} />
            <span>{row.year}</span>
            <LCEPerspective perspective={row.perspective} />
            <span>{row.events.join(" • ")}</span>
            <ShowRating {...{ row }} />
            <span>{compositeScore}</span>
            <DisplayLCEDirection elcedirection={row.elcedirection} />
            <ShowHighStateCount {...{ value: numIForYear, suffix: `I` }} />
            <ShowHighStateCount {...{ value: numPForYear, suffix: `P` }} />
        </div>
    );
}
